<template>
    <section class="element--cta cta" :style="[data.item ? {'backgroundColor': data.backgroundColour} : {'backgroundColor': 'transparent'}]">
        <div class="container">
            <div class="row"  v-if="data.items">
                <div v-for="(item, index) in data.items" :key="index" class="col-xs-12" :class="multipleColumns">
                    <div class="cta--content double">
                        <h3 v-animate="'slide-up'" class="delay-1">{{item.title}}</h3>
                        <div v-html="item.content" v-animate="'slide-up'" class="delay-2"></div>
                        <div class="cta-wrapper"> 
                        <a v-if="item.link" :target="item.openInNewWindow" v-animate="'slide-up'" class="button button--solid-black delay-3" :href="item.link" :aria-label="item.label" :title="item.label">{{item.label}}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="data.item">
                <div :class="singleColumn">
                    <div class="cta--content single">
                        <h2 v-animate="'slide-up'" class="delay-1">{{data.item.title}}</h2>
                        <div v-html="data.item.content" v-animate="'slide-up'" class="delay-2"></div>
                        <a v-if="data.item.link" :target="data.item.openInNewWindow" v-animate="'slide-up'" class="button button--solid-black delay-3" :href="data.item.link" :aria-label="data.item.label" :title="data.item.label">{{data.item.label}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "cta",
         props: {
            data: {
                type: Object
            }
        },
        computed: {
            singleColumn: function() {
                return 'col-sm-12 col-md-8 col-md-offset-2';
            },
            multipleColumns: function() {
                return 'col-sm-12 col-md-6';
            }
        }
    };
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/variables";
.cta--content {
    &.single {
        padding-top: 1rem;
        padding-bottom: 1rem;

        h2 {
            margin-top: 0;
        }
    }

    &.double {
        background-color: $color-megamenu-bg;
        margin-top: 20px;
        margin-bottom: 20px;
        height: auto;
        display:flex;
        flex-direction: column;



        @media #{$md} {
            margin: 0;
            height:100%;
            
        }

        @media #{$xl} {
            padding: 3rem;
        }

        h3 {
            margin-top: 0;

            @media #{$md} {
                font-size: 28px;
            }
        }


        .cta-wrapper{
            margin-top:auto;
            display:block;

        }
    }
}
</style>